import {
    CONTAINER_ID_ATTR, IMPRESSED_ITEM_ATTR,
    IMPRESSION_ITEM_ATTR,
    IMPRESSION_PARENT_ATTR
} from '../hooks/useImpressionContainer/consts';

export const getParentElements = (element, selector) => {
    const isClosestExists = typeof element.closest !== 'undefined';
    const closest = isClosestExists && element.closest(selector);

    if (!closest) {
        return [];
    }

    return [closest, ...getParentElements(closest.parentNode, selector)];
};

export const isElementOverflowsParent = (element, container) => {
    if (!element || !container) {
        return false;
    }

    const { left: containerLeft } = container.getBoundingClientRect();
    const { left: elementLeft } = element.getBoundingClientRect();

    return elementLeft > (container.clientWidth + containerLeft);
};

export const getParentImpId = (impressionId) => {
    const elementSelector = `[${IMPRESSION_ITEM_ATTR}="${impressionId}"]`;
    const element = document?.querySelector(elementSelector);

    if (!element) {
        return;
    }

    return element?.getAttribute(IMPRESSION_PARENT_ATTR);
};

export const getElementImpId = (element) => (element?.getAttribute(IMPRESSION_ITEM_ATTR));

export const getElementContainerId = (element) => (element?.getAttribute(CONTAINER_ID_ATTR));

export const markElementAsImpressed = (element) => element?.setAttribute(IMPRESSED_ITEM_ATTR, true);

export const isElementImpressed = (element) => (element?.getAttribute(IMPRESSED_ITEM_ATTR) === 'true');

export const getContainersData = (element) => {
    const containersList = getParentElements(element.parentElement, `[${CONTAINER_ID_ATTR}]`);
    const containerRef = containersList[0];
    const containerId = containerRef?.getAttribute(CONTAINER_ID_ATTR);

    return { containerId, containerRef, containersList };
};
